import { createSelector } from 'reselect';

const SafeModeData = () => state => state.get('emergencyMode');

export const emergencyModeStatusSelector = () =>
  createSelector(SafeModeData(), state => state.get('emergencyStatus'));

export const emergencyModeStatusLoadingSelector = () =>
  createSelector(SafeModeData(), state => state.get('loadingEmergencyStatus'));
